// Association.Capability — the atomic permission.
//
// Flexible-entity migration step 4 (.claude/analysis/flexible-entity-
// model.md §3.4). A capability is the unit application logic gates on —
// NEVER a role name. Roles are named compositions of capabilities
// (role.ts); the domain asks `can(actor, "resource:edit", target)`, so
// making roles admin-editable later (step 6) changes no call site.
//
// A bounded branded vocabulary. The constants below are the MVP set;
// new capabilities are additive strings. `mk` is the brand definition;
// `to` parses an untrusted string at the boundary, admitting only the
// known vocabulary so a typo can't mint a capability nothing grants.
export { CAPABILITIES, from, isKnown, mk, to };
import { Result } from "@bilda/utils";
import * as IdError from "../idError.js";
const mk = (s) => s;
const from = (c) => c;
// === The MVP capability vocabulary ===
//
// `resource:*` are the content verbs; `scope:manage_members` gates
// membership edits; `grant:manage` gates granting/revoking roles;
// `role:define` gates admin role editing (step 6); `package:export`
// gates the packaging pipeline; `annotation:create` is the reviewer's
// one write verb.
const RESOURCE_READ = mk("resource:read");
const RESOURCE_EDIT = mk("resource:edit");
const RESOURCE_DELETE = mk("resource:delete");
const RESOURCE_DUPLICATE = mk("resource:duplicate");
const SCOPE_MANAGE_MEMBERS = mk("scope:manage_members");
const GRANT_MANAGE = mk("grant:manage");
const ROLE_DEFINE = mk("role:define");
const PACKAGE_EXPORT = mk("package:export");
const ANNOTATION_CREATE = mk("annotation:create");
const CAPABILITIES = {
    resourceRead: RESOURCE_READ,
    resourceEdit: RESOURCE_EDIT,
    resourceDelete: RESOURCE_DELETE,
    resourceDuplicate: RESOURCE_DUPLICATE,
    scopeManageMembers: SCOPE_MANAGE_MEMBERS,
    grantManage: GRANT_MANAGE,
    roleDefine: ROLE_DEFINE,
    packageExport: PACKAGE_EXPORT,
    annotationCreate: ANNOTATION_CREATE,
};
const KNOWN = new Set(Object.values(CAPABILITIES));
const isKnown = (s) => KNOWN.has(s);
const to = (s) => isKnown(s)
    ? Result.ok(mk(s))
    : Result.err(IdError.mkMalformed("Capability", s));
//# sourceMappingURL=capability.js.map